import React from 'react';
import councilpoweredby from '../../assets/img/councilpoweredby.png';
import { isMobile } from '../../utils/screen';

const HeaderRoot = () => (
	<div style={{
		background: 'white',
		borderBottom: '1px solid gainsboro',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	}}>
		<div style={{
			width: '18%',
			margin: '.4em 0',
			display: 'flex',
			alignItems: 'center',
			marginLeft: '1em'
		}}>
			<img
				src={councilpoweredby}
				style={{
					objectFit: 'contain',
					height: isMobile ? '1.5em' : '2em'
				}} />
		</div>
		<div style={{ marginRight: '1em' }}>
			<i
				onClick={() => window.location.replace(window.location.origin)}
				className={'fa fa-search'}
				style={{
					color: 'black',
					cursor: 'pointer'
				}}
			/>
		</div>
	</div>
);

export default HeaderRoot;
